import React from 'react'

const Chat = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/chat',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M17.64 19l-5.36-2.32c-.68.188-1.412.275-2.28.275-4.963 0-9-3.579-9-7.978C1 4.578 5.037 1 10 1s9 3.578 9 7.977c0 1.77-.66 3.46-1.915 4.91L17.64 19z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        fill={secondaryColor}
        d='M6.25 8.18h7.5V6.584h-7.5zM6.25 11.37h5.25V9.776H6.25z'
      />
    </g>
  </svg>
)

export default Chat
